module.exports = __webpack_public_path__ + "img/首屏大banner@2x.f340f7b7.png";